const invert = require('lodash/invert');

const skus = {
  LMN: 'lmn',
  TJH: 'tjh',
  KOY: 'kingdom-of-you',
  TBT: 'birthday-thief',
  MGT: 'my-golden-ticket',
  TLB: 'littlest-bear',
  SCS: 'snowflake',
  MLM: 'little-monsters',
  TWR: 'wondrous-road',
  TPW: 'power-within',
  WAY: 'where-are-you',
  FMF: 'found-my-friends',
  MMK: 'magboggle-mystery',
  MSV: 'my-voice',
  ESC: 'elf-who-saved-christmas',
  WAB: 'where-are-you-activity-book',
  BFN: 'bedtime-for-name',
  WKN: 'what-kind-of-name',
  HBY: 'happy-birthday-to-you',
  TMC: 'thats-my-cake',
  DTD: 'dared-to-dream',
  YAE: 'you-are-extraordinary',
  WA2: 'where-are-you-2',
  DRT: 'dream-town',
  WWA: 'wonderbly-activity',
  CWY: 'christmas-wishes',
};

const slugs = {
  LMN: 'lost-my-name-book',
  TJH: 'the-journey-home-book',
  KOY: 'kingdom-of-you-book',
  TBT: 'the-birthday-thief-book',
  MGT: 'roald-dahl-my-golden-ticket-book',
  TLB: 'the-littlest-bear-book',
  SCS: 'the-christmas-snowflake-book',
  MLM: 'my-little-monster-name-book',
  TWR: 'the-wondrous-road-book',
  TPW: 'the-power-within-book',
  WAY: 'where-are-you-book',
  FMF: 'found-my-friends-book',
  MMK: 'the-curious-case-of-the-magboggle-mystery-kit',
  MSV: 'my-voice-book',
  ESC: 'elf-who-saved-christmas-book',
  WAB: 'where-are-you-activity-book',
  BFN: 'bedtime-for-name-book',
  WKN: 'what-kind-of-name-book',
  HBY: 'happy-birthday-to-you-book',
  TMC: 'thats-my-cake-book',
  DTD: 'dared-to-dream-book',
  YAE: 'you-are-extraordinary-book',
  WA2: 'where-are-you-2-book',
  DRT: 'dream-town-sticker-book',
  WWA: 'the-world-of-wonderbly-activity-book',
  CWY: 'christmas-wishes-book',
};

const museIds = {
  KOY: 'koy',
  TBT: 'bt',
  TJH: 'tjh',
  MGT: 'mgt',
  TLB: 'tlb',
  SCS: 'scs',
  MLM: 'mlm',
  TWR: 'twr',
  TPW: 'tpw',
  WAY: 'way',
  FMF: 'fmf',
  ESC: 'esc',
  BFN: 'bfn',
  WKN: 'wkn',
  HBY: 'hby',
  DTD: 'dtd',
  TMC: 'tmc',
  YAE: 'yae',
  WA2: 'wa2',
  DRT: 'drt',
  CWY: 'cwy',
};

// Used to calculate ratio in the book preview
const dimensions = {
  LMN: {
    width: 1280,
    height: 923,
  },
  TJH: {
    width: 1280,
    height: 906,
  },
  KOY: {
    width: 1280,
    height: 905,
  },
  TBT: {
    width: 1280,
    height: 906,
  },
  TLB: {
    width: 1280,
    height: 768,
  },
  SCS: {
    width: 1280,
    height: 768,
  },
  MLM: {
    width: 1280,
    height: 1280,
  },
  TWR: {
    width: 1280,
    height: 905.33,
  },
  FMF: {
    width: 1280,
    height: 906,
  },
  MGT: {
    width: 896,
    height: 1218,
  },
  TPW: {
    width: 896,
    height: 1218,
  },
  WAY: {
    width: 1227,
    height: 1575,
  },
  ESC: {
    width: 1280,
    height: 906,
  },
  BFN: {
    width: 1280,
    height: 1280
  },
  WKN: {
    width: 1280,
    height: 1280
  },
  HBY: {
    width: 1280,
    height: 1280
  },
  TMC: {
    width: 1280,
    height: 906,
  },
  DTD: {
    width: 1280,
    height: 906,
  },
  YAE: {
    width: 896,
    height: 1218,
  },
  DRT: {
    width: 896,
    height: 1218,
  },
  WA2: {
    width: 1227,
    height: 1575,
  },
  CWY: {
    width: 1280,
    height: 906,
  },
};

const findKeyBy = {
  sku: sku => invert(skus)[sku],
  slug: slug => invert(slugs)[slug],
};

const getProductByKey = key => ({
  sku: skus[key],
  slug: slugs[key],
  dimensions: dimensions[key]
});

const getProductBySlug = slug => {
  return getProductByKey(findKeyBy.slug(slug));
};

const getProductSlugByKey = key => {
  return slugs[key];
};

const getProductSlugBySku = sku => {
  return slugs[findKeyBy.sku(sku)];
};

module.exports = {
  skus,
  slugs,
  museIds,
  dimensions,
  findKeyBy,
  getProductByKey,
  getProductBySlug,
  getProductSlugByKey,
  getProductSlugBySku,
};



// WEBPACK FOOTER //
// ./src/common/config/product.js